import { render, staticRenderFns } from "./DataGeoMap.vue?vue&type=template&id=d99a9df6&scoped=true&"
import script from "./DataGeoMap.vue?vue&type=script&lang=js&"
export * from "./DataGeoMap.vue?vue&type=script&lang=js&"
import style0 from "./DataGeoMap.vue?vue&type=style&index=0&id=d99a9df6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d99a9df6",
  null
  
)

export default component.exports